import { render, staticRenderFns } from "./drugUS.vue?vue&type=template&id=3d3e9724&"
import script from "./drugUS.vue?vue&type=script&lang=js&"
export * from "./drugUS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports